// extracted by mini-css-extract-plugin
export default {"pcOverlay":"PcOverlayPanel_pcOverlay__m5JZL","pcContent":"PcOverlayPanel_pcContent__fRJja"};